export const responseOkExample = `{
  "totalItems": 47,
  "totalPages": 5,
  "currentPage": 1,
  "items": [
    "147748",
    "149250",
    "149250",
    "149250",
    "149250",
    "149250",
    "148070",
    "77060",
    "147779",
    "147595"
]}`;
